/* eslint-disable unused-imports/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SidebarState {
  options: Options[];
}

export type Options = {
  title: string;
  label?: string;
  icon: string;
  href: string;
  subMenu?: Options[];
};

const initialState: SidebarState = {
  options: [],
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setSidebarOptions(state, action: PayloadAction<Options[]>) {
      state.options = action.payload;
    },
    resetSidebar(state) {
      state = initialState;
    },
  },
});

export const { setSidebarOptions, resetSidebar } = sidebarSlice.actions;
export default sidebarSlice.reducer;
